var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"markdown-container theme-default-content"},[_c('head',{staticClass:"markdown"}),_c('body',{staticClass:"markdown"},[_c('h1',{staticClass:"markdown"},[_vm._v("SearchBar 搜索栏")])])])
}]

export { render, staticRenderFns }